// スネークケースからローワーキャメルケースに変換
export const toLowerCamel = (str: string) =>
  str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

// ネストされたオブジェクトのキーをローワーキャメルケースに変換
export const convertKeysDeepToLowerCamel = (data: object): object => {
  if (Array.isArray(data)) {
    return data.map(convertKeysDeepToLowerCamel);
  }

  if (data !== null && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        toLowerCamel(key),
        convertKeysDeepToLowerCamel(value)
      ])
    );
  }

  return data;
};
